module.exports = __webpack_public_path__ + "img/banner.e193de11.png";